export default () => ({
  SET_ITEM: (state, item) => (state.item = { ...item, password: "", password_confirmation: "" }),

  RESET_FILTERS: state => (state.filters = { organizations: [], ota_admin: false, organization_admin: false }),

  RESET_SORTING: state => (state.sorting = { type: "none" })
})
